import { QueryClient } from '@tanstack/vue-query'
import { isAppError } from '@shared/api/errors'

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        // client errors are final; only retry network/server failures
        retry: (count, error) =>
          count < 2 && (!isAppError(error) || error.kind === 'network' || error.kind === 'server'),
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  })
}
